module.exports = __webpack_public_path__ + "img/HLB.ec1fb3f1.png";